import 'cross-fetch/polyfill';
import '@babel/polyfill';
import 'core-js/fn/array/flat-map';
import 'core-js/es6/array';
import 'core-js/es7/object';
import 'core-js/fn/math/cbrt';
import 'core-js/fn/string/repeat';
import 'core-js/fn/object/assign';
import 'intersection-observer';
import 'core-js/es6/symbol';
import 'core-js/fn/promise';

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

if (!window.crypto) {
  (window as any).crypto = (window as any).msCrypto;
}
